const initialState = { mentionedNewEmail: '', isOpen: false };

export default function optionsForInviteToTeammateModal(state = initialState, action) {
  switch (action.type) {
    case 'SET_OPTIONS_FOR_INVITE_TO_TEAMMATE_MODAL':
      return action.payload;
    case 'RESET_OPTIONS_FOR_INVITE_TO_TEAMMATE_MODAL':
      return initialState;
    default:
      return state;
  }
}
